import axiosClient from "./axiosClient";

// const serviceUrl = "http://42.96.44.215:10002";
// http://42.96.44.215:10002/qlkhambenh/refraction/list-refraction?page=1&size=10
const commonCatalogService = {
  // Nation
  getListNation: async (page, size) => {
    const url = `/core-manager/nation/list-nation`;
    const params = { page: page, size: size };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getNation: async (id) => {
    const url = `/core-manager/nation`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  addNation: async (params) => {
    const url = `/core-manager/nation`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editNation: async (params) => {
    const url = `/core-manager/nation`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteNation: async (id) => {
    const url = `/core-manager/nation`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  // Staff Position
  getListStaffPosition: async (page, size) => {
    const url = `/core-manager/staff-position/list-staff-position`;
    const params = { page: page, size: size };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getStaffPosition: async (id) => {
    const url = `/core-manager/staff-position`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  addStaffPosition: async (params) => {
    const url = `/core-manager/staff-position`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editStaffPosition: async (params) => {
    const url = `/core-manager/staff-position`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteStaffPosition: async (id) => {
    const url = `/core-manager/staff-position`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },

  // Work Experience
  getListWorkExperience: async (page, size) => {
    const url = `/core-manager/work-experience/list-work-experience`;
    const params = { page: page, size: size };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getWorkExperience: async (id) => {
    const url = `/core-manager/work-experience`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  addWorkExperience: async (params) => {
    const url = `/core-manager/work-experience`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editWorkExperience: async (params) => {
    const url = `/core-manager/work-experience`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteWorkExperience: async (id) => {
    const url = `/core-manager/work-experience`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },

  // Tôn giáo
  getListTonGiao: async () => {
    const url = `/core-manager/ton-giao/list-ton-giao`;
    const params = { page: 1, limit: 100 };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getTonGiao: async (id) => {
    const url = `/core-manager/ton-giao`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  addTonGiao: async (params) => {
    const url = `/core-manager/ton-giao`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editTonGiao: async (params) => {
    const url = `/core-manager/ton-giao`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteTonGiao: async (id) => {
    const url = `/core-manager/ton-giao`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
};

export default commonCatalogService;
